module.exports = __webpack_public_path__ + "static/media/oak.a624b412.jpg";